import { WarningTwoIcon } from "@chakra-ui/icons";
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box,
} from "@chakra-ui/react";
import React from "react";

const ScratchathonDetails = () => {
    const accordianItems = [
        {
            title: (
                <p className="flex items-center font-semibold text-red-600 space-x-2">
                    <WarningTwoIcon />
                    <span>Recent Announcements and Eventns</span>
                </p>
            ),
            description: (
                <>
                    {/*<ul className="pl-4 list-disc space-y-1">
            <li>
            <span className="mr-1 font-bold">11/29/2020, 10:17 PM PST:</span>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit
          </li>
        </ul>*/}
                    <p className="text-gray-400">No announcements at the moment. Check back later!</p>
                </>
            ),
        },
        {
            title: <p>Overview of the Scratchathon</p>,
            description: (
                <p>
                    Welcome to the Scratchathon! Thank you for participating in the second YDC | Scratchathon. For this event, please create a small project aligning the theme "aliens" to showcase below. After submissions close on <it>1/17</it>, a few scratchers will judge your projects based on creativity, complexity, and skill.
                    <br />
                    We hope you have fun in the event. For inspiration, check out some of the great projects already submitted below. Enjoy!
                </p>
            ),
        },
        {
            title: <p>Submission Timing & Details</p>,
            description: (
                <ul className="pl-4 list-disc">
                    <li>Project due 12:00PM U.S. Pacific Time on 1.17.2021</li>
                    <li>Submissions must be hosted on scratch.mit.edu</li>
                    <li>Team projects are allowed, but they cannot be by more than 2 members</li>
                    <li>Please do not claim projects you did not make as yours. You will be removed, disqualified, and we will be sad :(</li>
                </ul>
            ),
        },
        {
            title: <p>Rules on Content, Assets, Music, and more</p>,
            description: (
                <p>
                    Please do not use copyrighted images or assets beyond the guidelines of Fair Use. As this is an educational event, most forms of copyright material usage would be allowed as long as it follows <a className="border-b border-gray-400 hover:border-gray-700 transition-all duration-700" href="https://scratch.mit.edu/terms_of_use/">Scratch's guidelines.</a>
                </p>
            ),
        },
    ];

    return (
        <div>
            <p className="mb-3 text-2xl font-medium leading-tight text-gray-800">
                More Details
            </p>

            <Accordion allowToggle allowMultiple defaultIndex={[0]}>
                {accordianItems.map((accordian, i) => {
                    return (
                        <div key={i} className="">
                            <AccordionItem defaultChecked={true}>
                                <AccordionButton>
                                    <Box flex="1" textAlign="left">
                                        {accordian.title}
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                                <AccordionPanel pb={4}>{accordian.description}</AccordionPanel>
                            </AccordionItem>
                        </div>
                    );
                })}
            </Accordion>
        </div>
    );
};

export default ScratchathonDetails;
